module.exports = __webpack_public_path__ + "static/media/01.Bhaskar Kamath with Puppets.d185949d.jpg";